<template>
    <section class="setting-profile-popup mfp-hide popup-save-document">
        <div class="setting-profile-wrapper delete-document-wrapper">
            <div class="save-document-form" v-if="!deleted">
                <h2>Are you sure?</h2>
                <p>Once you delete this document, it will be lost,<br>
                    nobody will be able to open it, and there’s no turning back.</p>
                <a href="javascript:;" @click="deleteDoc()" class="btn btn-outline-primary delete-btn">DELETE DOCUMENT</a>
                <p><a href="javascript:;" @click="deleteCancel()" class="btn-link">No Wait, I didn't want to do that!</a></p>
            </div>
            <div class="document-has-been-saved" v-else>
                <h4>Your Document has been deleted!</h4>
                <img src="/assets/img/delete-checkbox-icon.svg" alt="">
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "DeleteConfirm",
    data: function () {
        return {
            deleted: false,
        };
    },
    methods: {
        deleteDoc() {
            this.$parent.deleteDoc();
            this.deleted = true;

            setTimeout(() => {
                this.$parent.docId = null;
                this.$parent.confirm = false;
            }, 2000)
        },

        deleteCancel() {
            this.$parent.docId = null;
            this.$parent.confirm = false;
        }
    },
}
</script>

<style scoped>

</style>
